import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';
import Footer from './Footer';

export function FrontPage({
  children,
  isPhone,
  showLanguageSelector = false,
}: {
  children: ReactElement;
  isPhone: boolean;
  showLanguageSelector?: boolean;
}) {
  const { t } = useTranslation();
  if (isPhone) {
    return (
      <div className="login-page-wrapper phone">
        <Container maxWidth="xs" className="login-page-container login-page-scrollable">
          <div className="login-page-logo-container">
            <img src="Pluto_login_background_2.jpg" className="login-page-background" alt="Background" />
            <img
              src="svg/iTrack-white_ez.svg"
              className="login-page-logo"
              alt="iTrack logo"
              data-qa-element-id="phone_itrack_logo"
            />
            <img
              src="svg/image2vector_ez.svg"
              className="login-page-logo-svg"
              alt="Logo hexa"
              data-qa-element-id="phone_divider"
            />
          </div>
          <Box className="login-page-paper" sx={{ gap: showLanguageSelector ? 2 : undefined }}>
            {children}
            <Footer showLanguageSelector={showLanguageSelector} isPhone={isPhone} />
          </Box>
        </Container>
      </div>
    );
  } else {
    return (
      <div className="login-page-wrapper">
        <div className="login-page-left-wrapper">
          <img src="Pluto_login_background_2.jpg" className="login-page-background" alt="Background" />
          <div className="login-page-left-logo-text">
            <img
              src="svg/iTrack-white_ez.svg"
              className="login-page-left-logo"
              alt="iTrack logo"
              data-qa-element-id="itrack_logo"
            />
            <Typography className="login-page-left-text" data-qa-element-id="informative_text">
              {t('registration.footer')}
            </Typography>
          </div>
          <div className="login-page-left-hexa">
            <img
              src="svg/desktop_hexa_ez.svg"
              className="login-page-left-hexa-svg"
              alt="Logo hexa"
              data-qa-element-id="divider"
            />
          </div>
        </div>
        <div className="login-page-right-wrapper login-page-scrollable">
          <Container maxWidth="xs" className="login-page-container">
            <div className="login-page-paper">
              {children}
              <Footer showLanguageSelector={showLanguageSelector} isPhone={isPhone} />
            </div>
          </Container>
        </div>
      </div>
    );
  }
}
